import { render } from "./GmxHintLabel.vue?vue&type=template&id=7ebc17c4&scoped=true"
const script = {}

import "./GmxHintLabel.vue?vue&type=style&index=0&id=7ebc17c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ebc17c4"]])

export default __exports__